// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Evaluation of a single dimension of a submission
 */
export interface EvaluationDimensionOutput {
  /** level of performance */
  level?: unknown;
  /** comment on and justification of performance */
  comment?: unknown;
}
